import React from 'react';
import Image from 'next/image';
import styles from './Loader.module.css';

const Loader = ({ fullScreen = false }) => {
  return (
    <div className={`${styles.wrapper} ${fullScreen ? styles.fullScreen : ''}`}>
      <div className={styles.loader}>
        <div className={styles.box}>
          <div className={styles.logo}>
            <div className="relative w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center">
              <Image
                src="/logo.png"
                alt="Kaympus Loading..."
                width={70}
                height={70}
                className="object-contain"
                priority
                unoptimized
              />
            </div>
          </div>
        </div>
        <div className={`${styles.box} ${styles.box2}`} />
        <div className={`${styles.box} ${styles.box3}`} />
        <div className={`${styles.box} ${styles.box4}`} />
        <div className={`${styles.box} ${styles.box5}`} />
      </div>
    </div>
  );
};

export default Loader;

